/**
 * Prepara el cuerpo de la petición para guardar las características
 * @param {Object} updatedFeatures - Características actualizadas
 * @param {Object} originalFeatures - Características originales
 * @param {string} postingId - ID del posting
 * @returns {Object} Cuerpo de la petición
 */
function bodyManager(updatedFeatures, originalFeatures, postingId) {
  const body = { postingId, features: [] };

  const { featureChecks, featureSelect, featureInputs } = updatedFeatures;
  const featureChecksOriginals = originalFeatures.featureChecks;
  const featureSelectOriginals = originalFeatures.featureSelect;
  const featureInputsOriginals = originalFeatures.featureInputs;

  // Procesar los checkboxs
  featureChecks.forEach(updated => {
    const original = featureChecksOriginals.find(original => original.id === updated.id);
    // Si el campo se ha actualizado y su valor ha cambiado o si no existía antes
    if (updated.touched && original?.isChecked !== updated.isChecked) {
      body.features.push({ feature_id: updated.id, value: updated.isChecked });
    }
  });

  // Procesar los selects
  featureSelect.forEach(updated => {
    const original = featureSelectOriginals.find(original => original.id === updated.id);
    // Si el campo se ha actualizado y su valor ha cambiado o si no existía antes
    if (updated.touched && original?.value !== updated.value) {
      body.features.push({ feature_id: updated.id, value: updated.value ? updated.value : '0' });
    }
  });

  // Procesar los inputs
  featureInputs.forEach(updated => {
    const original = featureInputsOriginals.find(original => original.id === updated.id);
    const currentValue = updated.value || '';
    const originalValue = original ? original.value : '';
    // Si el campo se ha actualizado y su valor ha cambiado o si no existía antes
    if (updated.touched && currentValue !== originalValue) {
      body.features.push({
        feature_id: updated.id,
        value: currentValue === '' ? '0' : currentValue
      });
    }
  });

  return body;
}

export { bodyManager };
